import React from "react";
import { StateDispatchProps } from "../components/state-dispatch.props";
import { QqKeyInfoItemText } from "../model/qq-key-info-item.model";
import Box from "@mui/material/Box";
import { ResNoteTypography } from "./qq-typohraphy.controls";

export type QqResNoteControlProps = StateDispatchProps & QqKeyInfoItemText;

export const QqResNoteControl: React.FunctionComponent<QqResNoteControlProps> =
  ({ text }) => {
    return (
      <Box>
        <ResNoteTypography>{text}</ResNoteTypography>
      </Box>
    );
  };
